
import { Helmet } from "react-helmet";

const SwedishTermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Användarvillkor - Lainasampo.fi</title>
        <meta name="description" content="Användarvillkor för Lainasampo.fi lånejämförelsetjänst" />
      </Helmet>
      
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">Användarvillkor</h1>

        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            Detta är en översättning av våra finska användarvillkor. Den finska versionen är den juridiskt bindande versionen.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Tjänstebeskrivning</h2>
          <p className="mb-4">
            Lainasampo.fi är en lånejämförelse- och ansökningstjänst som vidarebefordrar låneansökningar till sina partners. 
            Lainasampo.fi beviljar inte själv lån, utan fungerar som en mellanhand mellan kunder och finansinstitut.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Användning av tjänsten</h2>
          <p className="mb-4">När du använder vår tjänst måste du:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Tillhandahålla korrekt och uppdaterad information i din låneansökan</li>
            <li>Vara minst 18 år gammal och juridiskt kompetent</li>
            <li>Använda tjänsten endast för lagliga ändamål</li>
            <li>Följa finsk lag och dessa användarvillkor</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Låneansökningar</h2>
          <p className="mb-4">Genom att skicka in en låneansökan via Lainasampo.fi:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Godkänner du att vi vidarebefordrar din ansökan till våra partners</li>
            <li>Accepterar du att våra partners kan kontrollera din kreditinformation</li>
            <li>Förstår du att det slutgiltiga lånebeslutet fattas av finansinstitutet, inte Lainasampo.fi</li>
            <li>Accepterar du att vi kan kontakta dig angående din låneansökan</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Låneerbjudanden</h2>
          <p className="mb-4">
            Låneerbjudanden görs av våra partners. Vi kan inte garantera att du kommer att få låneerbjudanden eller att erbjudandena 
            kommer att möta dina förväntningar. Villkoren för erbjudandena du får beror på flera faktorer, såsom din kreditinformation, 
            inkomst och utlåningspolicyer hos finansinstituten.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Kostnadsfritt</h2>
          <p className="mb-4">
            Lainasampo.fi:s tjänster är kostnadsfria för kunder. Vi finansierar vår verksamhet genom provisioner 
            som betalas av våra partners.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Ansvarsbegränsningar</h2>
          <p className="mb-4">Lainasampo.fi ansvarar inte för:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Lånebeslut som fattas av partners eller villkoren för deras erbjudanden</li>
            <li>Låneåterbetalning eller förhållanden mellan låntagaren och långivaren</li>
            <li>Indirekta eller följdskador som kan uppstå från användning av tjänsten</li>
            <li>Tillfälliga serviceavbrott eller tekniska problem</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Immateriella rättigheter</h2>
          <p className="mb-4">
            Allt innehåll på Lainasampo.fi, inklusive texter, bilder, logotyper, datorprogram och annat material, 
            är skyddat av immateriella rättigheter och tillhör Lainasampo Oy eller dess licensgivare. Kopiering, 
            distribution eller annan användning av innehållet utan tillstånd är förbjuden.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Kommunikation</h2>
          <p className="mb-4">
            Genom att använda vår tjänst accepterar du att vi kan skicka dig information om vår tjänst, din låneansökan 
            och låneerbjudanden via e-post eller andra elektroniska medel. Du kan när som helst återkalla ditt samtycke till 
            marknadskommunikation genom att kontakta vår kundtjänst.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Ändringar av villkor</h2>
          <p className="mb-4">
            Vi förbehåller oss rätten att ändra dessa användarvillkor. Vi kommer att publicera de ändrade villkoren på vår webbplats 
            och de träder i kraft omedelbart. Fortsatt användning av webbplatsen efter ändringar av villkoren kommer att 
            betraktas som ett godkännande av de nya villkoren.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">10. Tillämplig lag och tvistlösning</h2>
          <p className="mb-4">
            Dessa användarvillkor regleras av finsk lag. Eventuella tvister kommer i första hand att lösas genom 
            förhandling. Om en överenskommelse inte kan nås, kommer tvister att lösas i Helsingfors tingsrätt.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">11. Kontaktinformation</h2>
          <p className="mb-4">Om du har några frågor om användarvillkoren, vänligen kontakta:</p>
          <p>
            Lainasampo Oy<br />
            E-post: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-500 text-center mt-8 mb-8">Dessa villkor uppdaterades senast den: 1 juni 2023</p>
    </div>
  );
};

export default SwedishTermsPage;
